import { Typography } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export const ReportingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t('navigation.reporting')} | ${process.env.PROJECT_NAME}`}</title>
        <meta name="description" content={t('other.reporting-page-description')} />
      </Helmet>
      <Typography.Title level={3}>{t('other.reporting-page')}</Typography.Title>
    </React.Fragment>
  );
};
